import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColumnComponent } from './columns/column.component';
import { SpanColumnComponent } from './columns/span-column.component';
import { ColumnGroupComponent } from './columns/column-group.component';
import { FooterTemplateDirective } from './rendering/footer/footer-template.directive';
import { ColGroupComponent } from './rendering/common/col-group.component';
import { LoadingComponent } from './rendering/common/loading.component';
import { ResizableContainerDirective } from './layout/resizable.directive';
import { TemplateContextDirective } from './rendering/common/template-context.directive';
import { DetailTemplateDirective } from './rendering/details/detail-template.directive';
import { DraggableDirective } from './common/draggable.directive';
import { LogicalCellDirective } from './navigation/logical-cell.directive';
import { LogicalRowDirective } from './navigation/logical-row.directive';
import { FieldAccessorPipe } from "./rendering/common/field-accessor.pipe";
import { TableDirective } from "./column-resizing/table.directive";
import { FocusableDirective } from "./navigation/focusable.directive";
var exportedModules = [
    DraggableDirective,
    ColumnComponent,
    ColumnGroupComponent,
    LogicalCellDirective,
    LogicalRowDirective,
    FocusableDirective,
    FooterTemplateDirective,
    ColGroupComponent,
    ResizableContainerDirective,
    TemplateContextDirective,
    FieldAccessorPipe,
    DetailTemplateDirective,
    SpanColumnComponent,
    TableDirective,
    LoadingComponent
];
/**
 * @hidden
 */
var SharedModule = /** @class */ (function () {
    function SharedModule() {
    }
    SharedModule.exports = function () {
        return [
            ColumnComponent,
            SpanColumnComponent,
            ColumnGroupComponent,
            FooterTemplateDirective,
            DetailTemplateDirective,
            FocusableDirective
        ];
    };
    SharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [exportedModules],
                    exports: [exportedModules],
                    imports: [CommonModule]
                },] },
    ];
    /** @nocollapse */
    SharedModule.ctorParameters = function () { return []; };
    return SharedModule;
}());
export { SharedModule };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-grid/dist/es/shared.module.js
// module id = ../../../../@progress/kendo-angular-grid/dist/es/shared.module.js
// module chunks = vendor